import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button as MButton, Group } from '@mantine/core';
import {
    Button, ButtonGroup, ButtonToolbar, Col, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import { CheckboxField, InputField } from '../blocks/edit_blocks';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';

const PROJECTS = {
    'media.vkplay.ru': {
        id: 2,
        value: 'media.vkplay.ru',
        label: 'VK Play',
    },
    'gof.vkplay.ru': {
        id: 3,
        value: 'gof.vkplay.ru',
        label: 'Games of Future',
    },
};

export default class AdminPermissions extends React.Component {
    API_ENDPOINT_QS = '';

    constructor(props) {
        super(props);
        this.editUser = this.editUser.bind(this);
        this.resetEntity = this.resetEntity.bind(this);
        this.resetState = this.resetState.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.saveEntity = this.saveEntity.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.fillPerms = this.fillPerms.bind(this);
        this.permChange = this.permChange.bind(this);
        this.addUser = this.addUser.bind(this);
        this.selectAllPcRights = this.selectAllPcRights.bind(this);
        this.selectAllPcPocketsRights = this.selectAllPcPocketsRights.bind(this);

        this.state = {
            current: null,
            data: [],
            roles: [],
        };

        this.pc_entity = [
            { label: 'RAW HTML', type: 'rawhtml', subtype: '' },
            { label: 'TABLE HTML', type: 'tablehtml', subtype: '' },
            { label: 'Авторы', type: 'authors', subtype: '' },
            { label: 'Видео', type: 'videos', subtype: '' },
            { label: 'Диафильмы', type: 'films', subtype: '' },
            { label: 'Игры', type: 'games', subtype: '' },
            { label: 'Календарь', type: 'events', subtype: '' },
            { label: 'Каналы', type: 'channels', subtype: '' },
            { label: 'Карманы', type: 'pockets', subtype: 'barrel' },
            { label: 'Картинки', type: 'lastpics', subtype: '' },
            { label: 'Ключи', type: 'betakeys', subtype: '' },
            { label: 'Коллекции', type: 'collections', subtype: '' },
            { label: 'Железо и софт', type: 'articles', subtype: 'hard' },
            { label: 'F.A.Q.', type: 'articles', subtype: 'faq' },
            { label: 'Превью', type: 'articles', subtype: 'preview' },
            { label: 'Обзоры', type: 'articles', subtype: 'review' },
            { label: 'При поддержке', type: 'articles', subtype: 'story' },
            { label: 'Секреты', type: 'articles', subtype: 'secret' },
            { label: 'Статьи', type: 'articles', subtype: 'feat' },
            { label: 'Новости', type: 'news', subtype: '' },
            { label: 'Подборки', type: 'compilations', subtype: '' },
            { label: 'Премодерация UGC', type: 'ugc', subtype: '' },
            { label: 'Файлы', type: 'files', subtype: '' },
            { label: 'Рассылки', type: 'mail', subtype: '' },
            { label: 'Теги', type: 'tags', subtype: '' },
            { label: 'Коммерческие проекты', type: 'commercial', subtype: '' },
        ];

        this.pc_pockets_entity = [
            { label: 'COVID-19', type: 'pockets', subtype: 'covid' },
            { label: 'Главная MAIL.ru', type: 'pockets', subtype: 'main_mrg' },
            { label: 'Главная PC', type: 'pockets', subtype: 'main' },
            { label: 'Золотой фонд', type: 'pockets', subtype: 'best_entities' },
            { label: 'Популярное', type: 'pockets', subtype: 'popular' },
            { label: 'Перетяжки', type: 'pockets', subtype: 'breaking' },
            { label: 'Уведомления', type: 'pockets', subtype: 'notifications' },
            { label: 'Хайлайты', type: 'pockets', subtype: 'highlights' },
            { label: 'Хайлайты (мобильные)', type: 'pockets', subtype: 'highlights_mobile' },
        ];

        this.pc_stats_entity = [
            { label: 'Топ просмотров игр', type: 'stats', subtype: '' },
        ];

        this.pc_admin = [
            { label: 'Права доступа', type: 'admin', subtype: 'users' },
        ];

        this.projects = Object.values(PROJECTS);
    }

    componentDidMount() {
        Fetcher('admin/acl/roles/', 'GET', (data) => {
            if (!data.results) {
                return;
            }

            const roles = data.results.reduce((acc, current) => {
                acc[current.name] = {
                    id: current.id,
                    value: current.name,
                    label: current.description,
                };

                return acc;
            }, {});

            this.setState({ roles });
        });
    }

    resetState() {
        this.resetEntity();
        this.forceUpdate();
    }

    columns = [
        {
            Header: 'email',
            sortable: false,
            accessor: 'email',
            headerClassName: 'wordwrap',
        }, {
            Header: 'Имя',
            sortable: false,
            accessor: 'full_name',
        },
        {
            Header: 'Роль',
            sortable: false,
            accessor: 'role.name',
            Cell: (row) => (
                this.state.roles?.[row.value]?.label || null
            ),
        },
        {
            Header: '',
            sortable: false,
            accessor: 'id',
            maxWidth: 60,
            Cell: (row) => (
                <ButtonToolbar>
                    <ButtonGroup>
                        <Button
                            size="sm"
                            variant="link"
                            id={row.value}
                            data-value={row.row.email}
                            data-index={row.index}
                            onClick={this.editUser}
                        >
                            <FontAwesomeIcon id={row.value} data-value={row.row.email} icon="pencil-alt" />
                        </Button>
                        <Button
                            size="sm"
                            variant="link"
                            id={row.value}
                            data-value={row.row.email}
                            onClick={this.deleteUser}
                        >
                            <FontAwesomeIcon id={row.value} data-value={row.row.email} icon="trash" />
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            ),
        },
    ];

    fillPerms(data) {
        this.setState({ user_perms: data.results });
    }

    editUser(event) {
        const { index } = event.currentTarget.dataset;

        const current = this.state.data[index];

        this.setState({
            currentIndex: index,
            current: {
                ...current,
                projects: current.projects.map((project) => PROJECTS[project.name || project.value], []),
                role: this.state.roles[current.role.name],
            },
        });
    }

    deleteUser(event) {
        const user_id = event.currentTarget.id;
        const uri = `admin/acl/users/${user_id}`;
        Fetcher(uri, 'DELETE', this.resetState);
    }

    saveEntity() {
        const { current, currentIndex, data } = this.state;

        const newData = {
            full_name: current.full_name,
            projects: Object.values(current.projects).filter(project => !!project).reduce((acc, currentProject) => {
                acc.push(+currentProject.id);

                return acc;
            }, []),
            role: current.role.id,
        };

        const method = current.isNew ? 'POST' : 'PATCH';

        if (current.isNew) {
            newData.email = current.email;
        }

        Fetcher(`admin/acl/users/${current.id || ''}`, method, null, newData);

        const clonedData = JSON.parse(JSON.stringify(data));
        newData.projects = current.projects;
        newData.role = current.role;

        if (currentIndex) {
            clonedData[currentIndex] = {
                ...clonedData[currentIndex],
                ...newData,
            };
        } else {
            clonedData.push(newData);
        }

        this.setState({
            data: clonedData,
            current: null,
        });
    }

    resetEntity() {
        this.setState({ current: null });
    }

    handleChange(event) {
        this.setState({ [[event.currentTarget.id]]: event.currentTarget.value });
    }

    getPermState(type, subtype) {
        if (this.state.user_perms.some((e) => e.entity_type === type && e.entity_subtype === subtype)) {
            return true;
        }

        return false;
    }

    permChange(event) {
        const ent_type = event.currentTarget.id.split('/')[0];
        const ent_subtype = event.currentTarget.id.split('/')[1];
        const { checked } = event.currentTarget;
        const new_perms = [];
        Object.assign(new_perms, this.state.user_perms);
        for (let i = 0; i < new_perms.length; i++) {
            const entperm = new_perms[i];

            if (entperm.entity_type === ent_type && entperm.entity_subtype === ent_subtype) {
                new_perms.splice(i, 1);
            }
        }

        if (checked) {
            new_perms.push({ entity_type: ent_type, entity_subtype: ent_subtype });
        }

        this.setState({ user_perms: new_perms });
    }

    handleRoleChange = (role) => {
        this.setState({
            current: {
                ...this.state.current,
                role,
            },
        });
    };

    handleProjectChange = (projects) => {
        this.setState({
            current: {
                ...this.state.current,
                projects,
            },
        });
    };

    handleInputChange = (e) => {
        const { value, id } = e.currentTarget;

        this.setState({
            current: {
                ...this.state.current,
                [id]: value,
            },
        });
    };

    pcRights() {
        const checkboxes = [];

        let checkbox_row = [];
        let cell_count = 0;

        for (let i = 0; i < this.pc_entity.length; i++) {
            cell_count += 1;
            checkbox_row.push(
                <Col key={`chkbxcol_${i}`} md={4}>
                    <CheckboxField
                        name={`${this.pc_entity[i].type}/${this.pc_entity[i].subtype || ''}`}
                        label={this.pc_entity[i].label}
                        value={this.getPermState(this.pc_entity[i].type, this.pc_entity[i].subtype)}
                        onChange={this.permChange}
                    />
                </Col>,
            );

            if (cell_count === 3) {
                cell_count = 0;
                checkboxes.push(<Row key={`chkbx_${i}`}>{checkbox_row}</Row>);
                checkbox_row = [];
            }
        }

        checkboxes.push(<Row key="chkbxlst">{checkbox_row}</Row>);

        return checkboxes;
    }

    pcPocketsRights() {
        const checkboxes = [];
        let checkbox_row = [];
        let cell_count = 0;

        for (let i = 0; i < this.pc_pockets_entity.length; i++) {
            cell_count += 1;
            checkbox_row.push(
                <Col key={`chkbxcol_${i}`} md={4}>
                    <CheckboxField
                        name={`${this.pc_pockets_entity[i].type}/${this.pc_pockets_entity[i].subtype}`}
                        label={this.pc_pockets_entity[i].label}
                        value={this.getPermState(this.pc_pockets_entity[i].type, this.pc_pockets_entity[i].subtype)}
                        onChange={this.permChange}
                    />
                </Col>,
            );

            if (cell_count === 3) {
                cell_count = 0;
                checkboxes.push(<Row key={`chkbx_${i}`}>{checkbox_row}</Row>);
                checkbox_row = [];
            }
        }

        checkboxes.push(<Row key="chkbxlst">{checkbox_row}</Row>);

        return checkboxes;
    }

    pcStatsRights() {
        const checkboxes = [];
        let checkbox_row = [];
        let cell_count = 0;

        for (let i = 0; i < this.pc_stats_entity.length; i++) {
            cell_count += 1;
            checkbox_row.push(
                <Col key={`chkbxcol_${i}`} md={4}>
                    <CheckboxField
                        name={`${this.pc_stats_entity[i].type}/${this.pc_stats_entity[i].subtype}`}
                        label={this.pc_stats_entity[i].label}
                        value={this.getPermState(this.pc_stats_entity[i].type, this.pc_stats_entity[i].subtype)}
                        onChange={this.permChange}
                    />
                </Col>,
            );

            if (cell_count === 3) {
                cell_count = 0;
                checkboxes.push(<Row key={`chkbx_${i}`}>{checkbox_row}</Row>);
                checkbox_row = [];
            }
        }

        checkboxes.push(<Row key="chkbxlst">{checkbox_row}</Row>);

        return checkboxes;
    }

    pcAdminRights() {
        const checkboxes = [];
        let checkbox_row = [];
        let cell_count = 0;

        for (let i = 0; i < this.pc_admin.length; i++) {
            cell_count += 1;
            checkbox_row.push(
                <Col key={`chkbxcol_${i}`} md={4}>
                    <CheckboxField
                        name={`${this.pc_admin[i].type}/${this.pc_admin[i].subtype}`}
                        label={this.pc_admin[i].label}
                        value={this.getPermState(this.pc_admin[i].type, this.pc_admin[i].subtype)}
                        onChange={this.permChange}
                    />
                </Col>,
            );

            if (cell_count === 3) {
                cell_count = 0;
                checkboxes.push(<Row key={`chkbx_${i}`}>{checkbox_row}</Row>);
                checkbox_row = [];
            }
        }

        checkboxes.push(<Row key="chkbxlst">{checkbox_row}</Row>);

        return checkboxes;
    }

    addUser() {
        this.setState({
            current: {
                isNew: true,
            },
        });
    }

    selectAllPcRights() {
        const new_perms = [];
        Object.assign(new_perms, this.state.user_perms);
        for (let n = 0; n < this.pc_entity.length; n++) {
            let item_exist = false;
            const new_perm = this.pc_entity[n];

            for (let i = 0; i < new_perms.length; i++) {
                const current_perm = new_perms[i];

                if (current_perm.type === new_perm.type && current_perm.subtype === new_perm.subtype) {
                    item_exist = true;
                }
            }

            if (!item_exist) {
                new_perms.push({ entity_type: new_perm.type, entity_subtype: new_perm.subtype });
            }
        }

        this.setState({ user_perms: new_perms });
    }

    selectAllPcPocketsRights() {
        const new_perms = [];
        Object.assign(new_perms, this.state.user_perms);
        for (let n = 0; n < this.pc_pockets_entity.length; n++) {
            let item_exist = false;
            const new_perm = this.pc_pockets_entity[n];

            for (let i = 0; i < new_perms.length; i++) {
                const current_perm = new_perms[i];

                if (current_perm.type === new_perm.type && current_perm.subtype === new_perm.subtype) {
                    item_exist = true;
                }
            }

            if (!item_exist) {
                new_perms.push({ entity_type: new_perm.type, entity_subtype: new_perm.subtype });
            }
        }

        this.setState({ user_perms: new_perms });
    }

    editPermsBlock() {
        return (
            <Col md={7}>
                <Row>
                    <Col md={12}>
                        <h4>
                            Пользователь:
                            {this.state.current.email}
                        </h4>
                    </Col>
                </Row>
                {this.state.current?.isNew && (
                    <Row className="mb-3">
                        <Col md={4}>
                            <InputField
                                label="email"
                                name="email"
                                value={this.state.current.email}
                                onChange={this.handleInputChange}
                            />
                        </Col>
                    </Row>
                )}
                <Row className="mb-3">
                    <Col md={4}>
                        <InputField
                            label="Имя"
                            name="full_name"
                            value={this.state.current.full_name}
                            onChange={this.handleInputChange}
                        />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col md={12}>
                        <label className="form-label"><b>Роль</b></label>
                    </Col>
                    <Col md={4}>
                        <Select
                            name="role-select"
                            label="Роль"
                            options={Object.values(this.state.roles)}
                            value={this.state.current.role}
                            onChange={this.handleRoleChange}
                        />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col md={12}>
                        <label className="form-label"><b>Проекты</b></label>
                    </Col>
                    <Col md={4}>
                        <Select
                            name="project-select"
                            label="Проекты"
                            options={this.projects}
                            value={this.state.current.projects}
                            onChange={this.handleProjectChange}
                            isMulti
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button variant="outline-success" block onClick={this.saveEntity}>
                                    <FontAwesomeIcon
                                        icon="save"
                                    />
                                    {' '}
                                    Сохранить
                                </Button>
                            </ButtonGroup>

                            <ButtonGroup>
                                <Button variant="outline-secondary" block onClick={this.resetEntity}>
                                    <FontAwesomeIcon
                                        icon="undo"
                                    />
                                    {' '}
                                    Отмена
                                </Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                    </Col>
                </Row>
            </Col>
        );
    }

    render() {
        let show_perms_block = <h4>Не выбран пользователь для редактирования прав доступа</h4>;

        if (this.state.current) {
            show_perms_block = this.editPermsBlock();
        }

        return (
            <div className="container-fluid">
                <Row>
                    <Col md={5}>
                        <Row>
                            <Col md={12}>
                                <Group mb="xs" align="center">
                                    <h4 style={{ margin: 0 }}>Пользователи</h4>
                                    <MButton
                                        variant="outline"
                                        component={Link}
                                        color="dark"
                                        radius="md"
                                        size="xs"
                                        to="/contentmanager/admin/users/roles/"
                                    >
                                        Редактировать роли
                                    </MButton>
                                </Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <TableScreenWithoutUpdate
                                    handleDragEnd={this.dragEndHandle}
                                    columns={this.columns}
                                    endpoint={`admin/acl/users/?${this.API_ENDPOINT_QS}`}
                                    data={this.state}
                                    onFetchData={((data) => { this.setState({ data: data.data }); })}
                                    onChange={((data) => { this.setState({ data: data.data }); })}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <Button variant="outline-dark" onClick={this.addUser}>
                                    {' '}
                                    <FontAwesomeIcon icon="plus" />
                                    Добавить
                                    пользователя
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    {show_perms_block}
                </Row>

            </div>
        );
    }
}
